<template>
  <content-panel class="import-content-panel">
    <template v-slot:search>
      <search-box class="search-box">
        <el-form :inline="true" :model="searchForm" ref="searchForm" label-position="left" size="mini">
          <el-form-item label="导入日期：" prop="exportDate">
            <!-- <div class="date-item">
              <el-date-picker
                class="date-input"
                v-model="searchForm.startTime"
                type="date"
                size="mini"
                placeholder="开始日期">
              </el-date-picker>
              <span>-</span>
              <el-date-picker
                class="date-input"
                v-model="searchForm.endTime"
                type="date"
                size="mini"
                placeholder="结束日期">
              </el-date-picker>
            </div> -->
            <q-date-picker startFiled="startDate" endFiled="endDate" v-model="searchForm" ref="dateRef" />
          </el-form-item>
        </el-form>
        <template v-slot:right>
          <el-button size="small" type="primary" @click="onSearch">查询</el-button>
          <el-button size="small" @click="resetSearchForm">重置</el-button>
        </template>
      </search-box>
    </template>
    <table-panel class="tab-content">
      <import-task ref="importTask" class="task"></import-task>
    </table-panel>

    <import-dialog v-if="isShowImport" :visible.sync="isShowImport" @after="handleAfter" />
  </content-panel>
</template>

<script>
import ImportDialog from './import-dialog'
export default {
  name: 'ImportFile',
  components: {
    ImportDialog
  },
  data() {
    return {
      loading: false,
      isShowImport: false,
      searchForm: {
        startDate: '',
        endDate: ''
      }
    }
  },
  methods: {
    handleImport() {
      this.isShowImport = true;
    },
    handleAfter() {
      this.onSearch();
    },
    onSearch() {
      const filterParams = {
        reportType: "IMPORT",
        reportName: '',
        startDate: '',
        endDate: '',
        filterDTO: [],
        ...this.searchForm
      };

      this.$refs['importTask'].init(filterParams);
    },
    resetSearchForm() {
      this.$refs.searchForm.resetFields();
      this.searchForm.startDate = ''
      this.searchForm.endDate = ''
      this.$refs.dateRef.reset()
      this.onSearch();
    }
  },
  mounted() {
    this.onSearch();
  }
}
</script>

<style lang="stylus" scoped>
.date-item
  display flex 
  align-items center
  .date-input
    flex 1
  >span
    flex none
    margin 0 5px
.tab-content
  >>> .table-panel-content
    height calc(100vh - 140px)
  .task {
    >>> .el-button--mini {
      display: none
    }
  }
.import-content-panel
  >>> .main-area
    padding 0
</style>
<style lang="stylus">
.table-panel-content
  .root
    .el-container
      .page-header
        display none !important
    .main-weapper
      height 88%
    .el-table
      height calc(100% - 40px) !important
</style>
